import { Button, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { ButtonProps } from '@material-ui/core/Button';

interface Props extends ButtonProps {
  style?: Record<string, string>;
  linkText: string;
  linkUrl: string;
}

const CopyLinkButton = ({ ...props }: Props): JSX.Element => {
  const { style, linkText, linkUrl } = props;
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipText, setTooltipText] = useState('');

  return (
    <Tooltip
      title={tooltipText}
      open={showTooltip}
      onClose={() => setShowTooltip(false)}
      leaveDelay={1000}
    >
      <Button
        style={{ maxWidth: '100px', ...style }}
        fullWidth
        type="button"
        variant="raised"
        onClick={async () => {
          const htmlContent = `<a href="${linkUrl}">${linkText}</a>`;
          const plainTextContent = linkUrl;

          try {
            const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
            const textBlob = new Blob([plainTextContent], {
              type: 'text/plain',
            });

            const clipboardItem = new ClipboardItem({
              'text/html': htmlBlob,
              'text/plain': textBlob,
            });

            await navigator.clipboard.write([clipboardItem]);
            setTooltipText('Link copied to clipboard!');
          } catch (error) {
            setTooltipText(
              'Failed to copy. Your browser may not support this feature.'
            );
          }
          setShowTooltip(true);
        }}
      >
        {"Copy Link"}
      </Button>
    </Tooltip>
  );
};

export default CopyLinkButton;
